var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerInvitationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-insert-invitation",
    "data-name": "Icon material-insert-invitation",
    d: "M15.7,10.3h-4v4h4Zm-.8-8.8V3.1H8.5V1.5H6.9V3.1H6.1A1.593,1.593,0,0,0,4.508,4.7L4.5,15.9a1.6,1.6,0,0,0,1.6,1.6H17.3a1.6,1.6,0,0,0,1.6-1.6V4.7a1.6,1.6,0,0,0-1.6-1.6h-.8V1.5Zm2.4,14.4H6.1V7.1H17.3Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#16d696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerInvitationIcon);
export default __webpack_public_path__ + "static/media/banner-invitation-icon.ca74d4c0fd51608e0ddc3fbecc9f0835.svg";
export { ForwardRef as ReactComponent };